module.exports = __webpack_public_path__ + "img/remove_old_doorbell.f0eae75f.png";